import {
    GET_ORGANIZATIONS_REQUEST,
    GET_ORGANIZATIONS_SUCCESS,
    GET_ORGANIZATIONS_FAILURE
} from '../actions/actionTypes';

const initState = {
    isFetching: false,
    organizations: [],
    totalResults: 0,
    totalPages: 0,
    currentPage: 0,
};

const organizationsReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_ORGANIZATIONS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_ORGANIZATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                totalResults: action.response.totalResults,
                totalPages: action.response.totalPages,
                currentPage: action.response.page,
                organizations: action.response.resourceList,
            });
        case GET_ORGANIZATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                organizations: [],
                totalResults: 0,
                totalPages: 0,
                currentPage: 0
            });
        default:
            return state;
    }
};

export default organizationsReducer;